import {apiHelper} from "../redux/apiHelper"
export const getCmsSexualHealthSection=async()=>{
    try{
       let res=await apiHelper('get','/api/admin/cms-sexual-health-section/list');
       if(res){
         return res;
       }
    }catch(e){
     console.log(e);
    }
 }
 export const addCmsSexualHealthSection=async(data)=>{

    try{
        let res=await apiHelper('post',`/api/admin/cms-sexual-health-section/create`,data);
        if(res){
          return res;
        }
     }catch(e){
        console.log(e);
     }
 }
 export const updateCmsSexualHealthSection=async(id,data)=>{
   try{
       let res=await apiHelper('post',`/api/admin/cms-sexual-health-section/update/${id}`,data);
       if(res){
         return res;
       }
    }catch(e){
       console.log(e);
    }
}
export const getCmsSexualHealthSectionById=async(id)=>{
   try{
       let res=await apiHelper('get',`/api/admin/cms-sexual-health-section/get/${id}`);
       if(res){
         return res;
       }
    }catch(e){
     console.log(e);
    }
}
 export const deleteCmsSexualHealthSectionById=async(id)=>{
    try{
        let res=await apiHelper('delete',`/api/admin/cms-sexual-health-section/delete/${id}`);
        if(res){
          return res;
        }
     }catch(e){
      console.log(e);
     }
    
}